import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import ReactQuill from 'react-quill';
import * as profileActions from '../../../profile/actions';
import * as jobsActions from '../../../../../../actions/jobs/jobs';
import Loader from '../../../../../common/elements/Loader';
import ErrorModal from '../../../../../common/elements/ErrorModal';
import ThanksModal from '../../../../../common/elements/ThanksModal'
import BackButton from '../../../../../common/elements/BackButton'
import { remoteConfig } from "../../../../../../../../config/config";
import * as todoListActions from '../../../../../../actions/todo_list/todo_list';

class JobApplication extends Component {
    constructor() {
        super();
        this.state = {
            isThanks: false,
            isError: false,
            message: '',
            textFieldContent: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const { name, getProfile, job, getCurrentJob, params } = this.props,
            jobId = params.jobId,
            personId = localStorage.getItem('person_id');

        if (!name.first) getProfile(personId);
        if (!job) getCurrentJob(jobId);
        if (window.location.href.indexOf('?error') >= 0) this.setState({ isError: true });
        if (window.location.href.indexOf('?success') >= 0) this.setState({ isThanks: true });
    }

    handlePostToApi(e) {
        e.preventDefault();


        const { params, updateTodoList } = this.props, { jobId } = params,

            { textFieldContent } = this.state, personId = localStorage.getItem('person_id'),
            data = {}, form = new FormData();

        data.cv = e.target.elements["cv"].files[0];
        data.message = textFieldContent;


        if (data.cv === undefined && data.message === '') {
            this.setState({ isError: true, message: 'Please add a Cover Letter or CV to your application before submitting.' });
            return;
        }

        form.append("cv", data.cv)
        form.append("message", data.message)


        fetch(`https://jobs.${remoteConfig.urls.api}/jobs/${jobId}/apply/${personId}/internally`, {
            method: "post",
            mode: 'cors',
            headers: {
                'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
            },
            body: form,
        })
            .then((result) => {
                if (result.status !== 201) {
                    this.setState({ isError: true });
                } else {
                    this.setState({ isThanks: true });
                }
            }, (error) => {
                console.log("ERROR", error);
            }).catch(ex => console.log(ex));

        updateTodoList(personId, 2);
    }

    handleOnClose = (e) => {
        e.preventDefault();

        this.setState({ isThanks: false });
        browserHistory.push(`/jobs`);
    }

    render() {
        const { job, name } = this.props, { isThanks, isError } = this.state;

        if (!job || !name) return <Loader />;

        return (
            <article className="container jobs-body">
                <main className="row">
                    <BackButton />
                    <form className="form-application" id="job-application" onSubmit={(e) => this.handlePostToApi(e)}>
                        <div className="col-xs-12">
                            <h2 className="h2 text-center">Application Form</h2>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="field-box">
                                <label>Job Title:</label>
                                <input className="form-control" type='text' value={job && job.title} readOnly />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="field-box">
                                <label>Company:</label>
                                <input className="form-control" type='text' value={job && job.company && job.company.name} readOnly />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="field-box">
                                <label>First Name:</label>
                                <input className="form-control" type='text' value={name && name.first} readOnly />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="field-box">
                                <label>Last Name:</label>
                                <input className="form-control" type='text' value={name && name.last} readOnly />
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className="field-box">
                                <label>Cover Letter</label>
                                <ReactQuill onChange={(value) => this.setState({ textFieldContent: value })} />
                            </div>
                        </div>
                        <div className="col-xs-12 text-center">
                            <div className="form-group">
                                <h3 className="h3">Add a CV to your job application</h3>
                                <input className="center-block" type="file" name="cv" />
                                <p className="p-tag help-block">Choose your file and press submit</p>
                                <p className="p-tag help-block">(Files must be in .pdf or .doc format and not exceed 2Mb)</p>
                            </div>
                        </div>
                        <div className="col-xs-12 text-center">
                            <ul className="buttons-center">
                                <li>
                                    <button type="button" className="btn btn-warning"
                                        onClick={() => browserHistory.goBack()}>
                                        <span className="label">Cancel</span>
                                        <span className="icon"><i className="fa fa-times fa-left" /></span>
                                    </button>
                                </li>
                                <li>
                                    <button type="submit" className="btn btn-primary">
                                        <span className="label">Submit</span>
                                        <span className="icon"><i className="fa fa-check fa-right" /></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </form>
                </main>
                <ThanksModal isOpen={isThanks} onClose={(e) => this.handleOnClose(e)}
                    message="Thank you, your job application has been submitted." />
                <ErrorModal isOpen={isError} onClose={() => this.setState({ isError: false, message: '' })}
                    message={this.state.message ? this.state.message : 'The file type used is not supported. Please try again'} />
            </article>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        name: state.profile.name,
        job: state.jobs.current_job,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProfile: (personId) => dispatch(profileActions.getProfile(personId)),
        getCurrentJob: (jobId) => dispatch(jobsActions.getCurrentJob(jobId)),
        updateTodoList: (personId, listItem) => dispatch(todoListActions.updateTodoList(personId, listItem))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(JobApplication);


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplication.js